import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function PublicRoute({ children, redirectIfAuthenticated = false }) {
  const { isAuthenticated } = useAuth();

  if (redirectIfAuthenticated && isAuthenticated()) {
    // User is authenticated, redirect to dashboard
    return <Navigate to="/dashboard" replace />;
  }

  // Render the public content
  return children;
}

export default PublicRoute;
